import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/room-meeting-service";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  id_room_meeting?: number;
};

export interface listTypeGetRoomMeetingServiceList extends listType { }

export class roomMeetingServiceApi extends BaseAPI {
  static getRoomMeetingServiceList(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static getRoomMeetingServiceById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static createRoomMeetingService(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateARoomMeetingService(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteRoomMeetingService(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
